import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Goto from '@/views/Goto.vue';
import DapperCallback from '@/views/DapperCallback.vue';
import DapperAuthError from '@/views/DapperAuthError.vue';

Vue.use(Router);

// For each route, you assign a component that gets rendered inside <router-view></router-view> in App.vue, just below the navbar (see App.vue).
// I'm not sure why the Vue CLI created two different directories, views and components, but I think they meant for components that are full views
// to be put in views, and just modular components to be put in components. Here, we can use either components in the views dir (like Callback and About),
// or in the components dir. Doesn't really seem to matter, as components can always house other components.
// Yes, seems like it's really just convention - https://stackoverflow.com/questions/50865828/what-is-the-difference-between-the-views-and-components-folders-in-a-vue-project
// And, according to this, views directory didn't use to exist - https://blog.pusher.com/new-vue-cli-simplifies-development/
// BTW, you can also have named router views - https://router.vuejs.org/guide/essentials/named-views.html#nested-named-views
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/goto/:linkType/:payload',
      name: 'goto',
      component: Goto,
    },
    {
      path: '/dapper/auth/callback',
      name: 'dapperCallback',
      component: DapperCallback,
    },
    {
      path: '/dapper/auth/error',
      name: 'dapperAuthError',
      component: DapperAuthError,
    },    
    {
      path: '/myaccount/',
      name: 'myaccount',
      component: () => import(/* webpackChunkName: "test" */ '../views/MyAccount.vue'),
    },
    {
      path: '/deals/:mode?',
      name: 'deals',
      component: () => import(/* webpackChunkName: "test" */ '../views/Deals.vue'),
    },
    {
      path: '/offers/:mode?',
      name: 'offers',
      component: () => import(/* webpackChunkName: "test" */ '../views/Offers.vue'),
    },    
    {
      path: '/listings/:mode?',
      name: 'listings',
      component: () => import(/* webpackChunkName: "test" */ '../views/Marketplace.vue'),
    },    
    {
      path: '/challenges/:mode?',
      name: 'challenges',
      component: () => import(/* webpackChunkName: "test" */ '../views/Challenges.vue'),
    },
    {
      path: '/community-tools/:mode?',
      name: 'tools',
      component: () => import(/* webpackChunkName: "test" */ '../views/Tools.vue'),
    },
    {
      path: '/leaderboards/:mode?',
      name: 'leaderboards',
      component: () => import(/* webpackChunkName: "test" */ '../views/Leaderboards.vue'),
    },    
    {
      path: '/confirm/:code',
      name: 'confirm',
      component: () => import(/* webpackChunkName: "test" */ '../views/Confirm.vue'),
    },
    {
      path: '/forgotPassword/:code',
      name: 'forgotPassword',
      component: () => import(/* webpackChunkName: "test" */ '../views/ForgotPassword.vue'),
    },
    {
      path: '/m/:code',
      name: 'm',
      component: () => import(/* webpackChunkName: "test" */ '../views/MagicURL.vue'),
    },
    {
      path: '/unsubscribe/:code',
      name: 'unsubscribe',
      component: () => import(/* webpackChunkName: "test" */ '../views/Unsubscribe.vue'),
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: () => import(/* webpackChunkName: "test" */ '../views/PrivacyPolicy.vue'),
    },
    {
      path: '/tos',
      name: 'tos',
      component: () => import(/* webpackChunkName: "test" */ '../views/TOS.vue'),
    },
    {
      path: '/discordConfirm/:code',
      name: 'discordConfirm',
      component: () => import(/* webpackChunkName: "test" */ '../views/DiscordConfirm.vue'),
    },    
  ],
});

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
  // if the to route doesn't match any defined routes, redirect to /
  if (to.matched.length === 0) {
    console.log(`router.beforeEach() found no matches for ${JSON.stringify(to)}`)
    next('/')
  }

  if (to.name && to.name.includes('callback')) { // check if "to"-route is "callback" and allow access
    next();
  } else {
    next();
  }
});

export default router;

